import { render, staticRenderFns } from "./DatasetsList.vue?vue&type=template&id=148d474d&scoped=true"
import script from "./DatasetsList.vue?vue&type=script&lang=js"
export * from "./DatasetsList.vue?vue&type=script&lang=js"
import style0 from "./DatasetsList.vue?vue&type=style&index=0&id=148d474d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148d474d",
  null
  
)

export default component.exports